import classNames from "classnames";
import { Dialog } from "primereact/dialog";
import _ from './../../../../i18n';
import { Checkbox, Input } from "antd";
import { isMailSentToClientWithStatus } from "../../services";
import { WarningOutlined } from "@ant-design/icons";
import { LoadingIcon } from "../../../common/Icons";
import './SendMailToClientModal.scss';
import { validateEmail } from "../../../../utils";

export default function SendMailToClientModal({
  isOpen,
  onClose,
  onConfirm,
  client,
  additionalEmail,
  setAdditionalEmail,
  useAdditionalEmail,
  setUseAdditionalEmail,
  isSending
}) {
  return (
    <Dialog
      visible={isOpen}
      onHide={() => {
        onClose();
      }}
      header="Envoyer un mail au client"
      className="send-email-dialog"
      style={{ width: '530px' }}
      footer={
        <div className="send-email-footer">
          <button
            className="send-email-cancel-button"
            onClick={() => {
              onClose();
            }}
          >
            {_("cancel")}
          </button>
          <button
            className={classNames("send-email-send-button", {
              "send-email-send-button-disabled": (!client?.email && !validateEmail(additionalEmail)) ||
              (client.email && (useAdditionalEmail && !validateEmail(additionalEmail))) ||
              isSending
            })}
            onClick={onConfirm}
            disabled={
              (!client?.email && !validateEmail(additionalEmail)) ||
              (client.email && (useAdditionalEmail && !validateEmail(additionalEmail))) ||
              isSending
            }
          >
            {isSending && (
              <LoadingIcon color="#fff" size={16} />
            )}
            {
              isMailSentToClientWithStatus(client?.status, client?.emailNotificationsSent) ?
              'Renvoyer' : 'Envoyer'
            }
          </button>
        </div>
      }
    >
      <div className="send-email-content">
        <div className="current-email">
          {client?.email ? (
            <>
              {isMailSentToClientWithStatus(client?.status, client?.emailNotificationsSent) && (
                <div className="already-sent-text">
                  <WarningOutlined />
                  <p>
                    Un mail a déjà été envoyé au client à l'adresse{" "}
                    <strong>{client.emailNotificationsSent[
                      'as' + client.status.charAt(0).toUpperCase() + client.status.slice(1).toLowerCase()
                    ]?.to}</strong>.
                  </p>
                </div>
              )}
              <span>L'adresse email du client est : </span>
              <strong>{client.email}</strong>
            </>
          ) : (
            <span>Le client n'a pas d'adresse email.</span>
          )}
        </div>

        <div className="additional-email">
          <div className="additional-email-checkbox-container">
            <Checkbox
              className="additional-email-switch"
              size="small"
              checked={useAdditionalEmail}
              onChange={() => setUseAdditionalEmail(!useAdditionalEmail)}
            />
            <label
              htmlFor="additional-email-checkbox"
              className="additional-email-checkbox-label"
              onClick={() => setUseAdditionalEmail(!useAdditionalEmail)}
            >
              {client?.email
                ? "Utiliser une autre adresse email"
                : "Saisir une adresse email"}
            </label>
          </div>

          {useAdditionalEmail && (
            <Input
              className="additional-email-input"
              placeholder="Saisir une autre adresse email"
              value={additionalEmail}
              onChange={(e) => setAdditionalEmail(e.target.value)}
              type="email"
              status={(additionalEmail && !validateEmail(additionalEmail)) ? "error" : null}
            />
          )}
        </div>
      </div>
    </Dialog>
  )
}
